import { createSelector } from '@reduxjs/toolkit';

export const selectParameterComplianceState = (state) => state.parameterCompliance;

export const selectLoading = (state) => state.parameterCompliance?.loading;
export const selectFiltersLoading = (state) => state.parameterCompliance?.filtersLoading;
export const selectComplianceData = (state) => state.parameterCompliance?.complianceData;
export const selectParameters = (state) => state.parameterCompliance?.parameters || [];
export const selectTotalParameters = (state) => state.parameterCompliance?.totalParameters || 0;
export const selectTestTypes = (state) => state.parameterCompliance?.testTypes || [];

export const selectTotalSamplesTested = (state) =>
  state.parameterCompliance?.complianceData?.totalSamplesTested || 0;
export const selectCompliantSamples = (state) =>
  state.parameterCompliance?.complianceData?.compliantSamples || { count: 0, percentage: 0 };
export const selectUnsafeSamples = (state) =>
  state.parameterCompliance?.complianceData?.unsafeSamples || { count: 0, percentage: 0 };
export const selectSubStandardSamples = (state) =>
  state.parameterCompliance?.complianceData?.subStandardSamples || { count: 0, percentage: 0 };
export const selectMisLabelledSamples = (state) =>
  state.parameterCompliance?.complianceData?.misLabelledSamples || { count: 0, percentage: 0 };

export const selectTestTypeOptions = createSelector(
  [selectTestTypes],
  (testTypes) => {
    if (!Array.isArray(testTypes)) {
      console.warn('testTypes is not an array:', testTypes);
      return [];
    }
    return testTypes.map(testType => ({
      label: testType.name,  
      value: testType.name    
    }));
  }
);

export const selectParametersTableData = createSelector(
  [selectParameters],
  (parameters) =>
    parameters.map((param, index) => ({
      key: index,
      parameter: param.parameter,
      total: param.total,
      safe: param.safe,
      unsafe: param.unsafe,
      standard: param.standard,
      subStandard: param.subStandard,
      unit: param.unit,
      safetyCompliance: param.safetyCompliance,
      qualityCompliance: param.qualityCompliance,
      overallCompliance: param.overallCompliance,
      compliancePercentage: param.compliancePercentage,
      parameterType: param.parameterType,
      testType: param.testType
    }))
);

export const selectComplianceMetrics = createSelector(
  [
    selectTotalSamplesTested,
    selectCompliantSamples,
    selectUnsafeSamples,
    selectSubStandardSamples,
    selectMisLabelledSamples
  ],
  (totalSamples, compliant, unsafe, subStandard, misLabelled) => ({
    totalSamples,
    compliant,
    unsafe,
    subStandard,
    misLabelled
  })
);